import { types } from './actions'

export default function loginRedcer(state = {}, action) {
    switch (action.type) {
        case types.SET_USER_LOGGED:
            return { ...state, userLogged: action.user }
        default:
            return state
    }
}